<template>
		<div class="content crfff account-bg" style="height: 100%;">
      <div class="info">
        <div class="back" @click="back" style="margin-top: 0;">
          <img width="50" src="../../static/images/back.png" />
        </div>
        <div class="at-img ac por">
          <input class="upload-image" type="file" @change="handleFileUpload" accept="image/*">
          <img class="account-img" :src="info.avatar" />
        </div>
        <div class="account-content">
          <div class="ac">
            <div v-if="isEdit" class="flex" style="margin:20px 0;">
              <input class="fen" style="margin:0px 10px 0 0;width:70%;font-size: 28px;" v-model="nickname" />
              <button class="button" style="width: 30%;padding: 14px 20px;" @click="editSub">{{$t('Submit')}}</button>
            </div>
            <div v-else>
              <span class="name-span app-en">{{info.nickname}}</span>
              <span class=" crff1d4f fs33" @click="editName">
                <img width="60" class="edit" src="static/images/edit.png" />
              </span>
            </div>
          </div>
          <div class="account-center">
            <div class="at-li ac">
              <img width="70" src="../../static/images/rank-icon.png">
              <div class="name">
                {{$t('Rank')}}
              </div>
              <div class="fwb">
                <span class="fs26">{{info.rank}}</span>
              </div>
            </div>
            <div class="at-border"></div>
            <div class="at-li ac">
              <img width="70" src="../../static/images/points-icon.png">
              <div class="name">
                {{$t('Points')}}
              </div>
              <div class="fwb">
                <span class="fs26">{{info.points}}</span>
              </div>
            </div>
            <div class="at-border"></div>
            <div class="at-li ac">
              <img width="70" src="../../static/images/chances-icon.png">
              <div class="name">
                {{$t('Chances')}}
              </div>
              <div class="fwb">
                <span class="fs26">{{info.score}}</span>
              </div>
            </div>
          </div>
          <div class="mt50">
            <div class="fwb">
              <div class="name fw7 fs20 ac">
               {{$t('phoneNumber')}}
              </div>
              <div class="fen">
                <span class="fs26">{{info.mobile}}</span>
              </div>
            </div>
            <div class="fwb">
              <div class="name fw7 fs20 ac">
                {{$t('Level')}}
              </div>
              <div class="fen">
                <span class="fs26">{{info.level}}</span>
              </div>
            </div>
            <div class="fwb">
              <div class="name fw7 fs20 ac">
                {{$t('MemberSince')}}
              </div>
              <div class="fen">
                <span class="fs26">{{info.jointime}}</span>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/HeaderTwo'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          isEdit:false,
          info:'',
          nickname:'',
          base64Image:''
        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();

	},
    methods: {
      handleFileUpload(event) {
        let that = this;
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            console.log(e);
            this.base64Image = e.target.result;

            // 从Base64字符串中提取图片类型
            const matches = this.base64Image.match(/^data:image\/([A-Za-z-+/]+);base64,/);
            const type = matches ? matches[1] : '';

            that.uploadImage(type);
          };
          reader.readAsDataURL(file);
        }
      },

      async uploadImage(imageType) {
        let that = this
        if (!this.base64Image) {
          alert('请先选择图片');
          return;
        }
        try {
          let data = {
            image: {
              "content": this.base64Image,
              "type": imageType || "" // 使用提取的类型，如果没有则留空
            }
          }
          that.$parent.loadModal(true);
          that.$api.post('/api/user/upload_avatar', data, r => {
            that.$parent.returnCode(r, function() {
              console.log('上传成功', r.data);
              that.getHome()
              that.$parent.loadModal(false);
            });
          })
        } catch (error) {
          console.error('上传失败', error);
        }
      },
		back(){
			this.$router.go(-1);
		},
    editName(){
      this.isEdit = true
      this.nickname = this.info.nickname
    },
    editSub(){
      let that =this;
      let data = {
        nickname:that.nickname
      }
      //that.$parent.loadModal(true);
      that.$api.post('/api/user/profile',data,r =>{
      	that.$parent.returnCode(r,function(){
      		//that.info = r.data
          that.isEdit = false
          that.getHome()
      		that.$parent.loadModal(false);
        });

      })
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
        });

			})
		},
	}
}
</script>
<style>
  .account-content{background: #fff;border-radius: 60px;padding: 100px 40px 20px;color:#454545 !important}
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue